import { Card, Col, Row, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { Container } from '../../styles/commonStyles';
import {
  SVGLogoDark,
  SVGKnowledge,
  SVGDiagnose,
  SVGInsight,
} from '../../images';
import Icon from '@ant-design/icons';
import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router';
import { CardTitle, WelcomeText } from './styles';

const cards = [
  {
    route: 'diagnose',
    title: 'dashboard_dignose',
    icon: SVGDiagnose,
  },
  {
    route: 'knowledge',
    title: 'dashboard_knowledge_base',
    icon: SVGKnowledge,
  },
  {
    route: 'insight',
    title: 'dashboard_analyse',
    icon: SVGInsight,
  },
];

const Dashboard = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Container style={{ height: '100%' }}>
      <Flex
        style={{
          height: '100%',
          maxWidth: '1200px',
          padding: '0 24px',
          margin: '0 auto',
        }}
        justify="center"
        vertical
      >
        <Flex vertical justify="center" align="center">
          <SVGLogoDark width={240} />
          <WelcomeText>What do you want to solve today?</WelcomeText>
        </Flex>

        <Row gutter={24} style={{ marginTop: '75px' }}>
          {cards.map((card) => (
            <Col span={8} key={card.route}>
              <Card hoverable onClick={() => navigate(card.route)}>
                <Flex vertical justify="center" align="center">
                  <Icon
                    component={card.icon}
                    style={{ fontSize: 80, color: theme.antd.colorPrimary }}
                  ></Icon>
                  <CardTitle>{t(card.title)}</CardTitle>
                </Flex>
              </Card>
            </Col>
          ))}
        </Row>
      </Flex>
    </Container>
  );
};

export default Dashboard;
